var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"metadata_container"},[_c('v-treeview',{staticClass:"metadata_tree",attrs:{"dense":"","dark":"","items":_vm.metadata,"open-on-click":""}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }